
.root .list {
	margin-bottom: 0;
}

.panel {
	position: relative;
}

.copy {
	position: absolute;
	top: var(--tags-spacing);
	right: var(--tags-spacing);
}

.pre {
	margin: 0;
	padding: var(--content-padding-base);
	overflow-x: auto;
	border: 1px solid var(--pre-border-color);
	border-top: 0;
	border-radius: 0 0 var(--border-radius-base) var(--border-radius-base);
	background-color: var(--pre-bg);
	/* room for the copy button, which floats over the top-right corner */
	padding-right: calc(var(--content-padding-base) + 46px);
}

.code {
	color: var(--text-color);
	font-family: var(--font-family-monospace);
	font-size: var(--font-size-small);
	line-height: 1.5;
	white-space: pre;
	tab-size: 4;
}

.secret {
	padding: 0 2px;
	border-radius: var(--border-radius-small);
	background-color: var(--tags-bg);
	color: var(--input-group-addon-color);
	text-decoration: underline dotted;
	text-underline-offset: 2px;
	cursor: help;
}
